<template>
    <div>
        <button @click="showShareDialog" type="button" class="btn btn-lg btn-secondary font-semibold rounded-full">
            <i class="fad fa-share-alt fa-lg mr-2"></i>
            Share
        </button>

        <!-- <portal v-if="showModal" to="modals" transition="fade-transition"> -->
        <portal v-if="showModal" to="modals">
            <share-modal v-if="showModal" @close="onShareModalClosed" :page-url="pageUrl" :title="title" :description="description" />
        </portal>
    </div>
</template>

<script>
/**
 * @see https://w3c.github.io/web-share/
 * @see https://medium.com/@axelhodler/web-share-api-in-vue-js-f5b65db80f28
 * @see https://css-tricks.com/how-to-use-the-web-share-api/
 * @see https://alligator.io/js/web-share-api/
 * @see https://github.com/christophery/good-share
 * @see https://ellisonleao.github.io/sharer.js/
 */
export default {
    props: [
        'page-url',
        'title',
        'description'
    ],

    data: () => ({
        showModal: false,
        sharing: {
            url: '',
            title: '',
            description: ''
        }
    }),

    created() {
        this.sharing.url = this.pageUrl || window.location.href;
        this.sharing.title = this.title;
        this.sharing.description = this.description;
    },

    mounted() {},

    computed: {},

    methods: {
        onShareModalClosed() {
            this.showModal = false;
        },

        showShareModal() {
            this.showModal = true;
        },

        showShareDialog() {
            if (navigator.share) {
                this.showDeviceShare();
                return;
            }

            this.showShareModal();
        },

        showDeviceShare() {
            navigator.share({
                title : this.sharing.title,
                text  : this.sharing.description,
                url   : this.sharing.url
            })
                .then(() => {
                    this.trackRawEvent('share', {
                        url : this.sharing.url
                    });
                })
                .catch(err => {
                    console.error(err);
                    // console.log(`Error while sharing content`, err.message);
                });
        }
    }
}
</script>

<style lang="scss" scoped>
</style>
